<template>
  <div class="sh-vxe-table">
    <vxe-table v-bind="$attrs" v-on="$listeners" ref="vxeTableRef">
      <template v-for="(_, name) in $slots" :slot="name">
        <slot :name="name" />
      </template>
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="props">
        <slot :name="name" v-bind="props" />
      </template>
    </vxe-table>
    <div class="page-box" v-if="pageShow" :style="{ textAlign: pageAlign || 'right' }">
      <el-pagination
        ref="elPaginationRef"
        :current-page.sync="$attrs['current-page']"
        :page-size="$attrs['page-size'] || pageSize"
        :total="$attrs['total'] || total"
        :layout="$attrs['layout'] || layout"
        :page-size-options="$attrs['page-sizes'] || pageSizes"
        v-on="$listeners"
        v-bind="$attrs"
        @current-change="$listeners['page-current-change']"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShVxeTable',
  props: {
    pageShow: {
      type: Boolean,
      default: true
    },
    pageAlign: {
      type: String,
      default: 'right'
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50, 100],
      pageSize: 20,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 100
    }
  }
}
</script>

<style lang="scss">
.page-box {
  margin-top: 16px;
}
.sh-vxe-table-tool {
  margin-bottom: 16px;
}
</style>
